import { cdnOrigin, publicOrigin } from '@maxpreps/network/src/origins';
import styled from 'styled-components';

const StyledLogoWrapper = styled.a`
  display: inline-block;

  &:hover {
    opacity: 0.6;
  }
`;

const StyledLogo = styled.img`
  width: 175px;
  height: 50px;
  display: block;
`;

const Logo = () => (
  <StyledLogoWrapper href={`${publicOrigin}/`}>
    <StyledLogo
      src={`${cdnOrigin}/includes/images/membership/coach/m-p-logo-218x62.png`}
      alt="MaxPreps Logo"
      loading="lazy"
    />
  </StyledLogoWrapper>
);

export default Logo;
